// extracted by css-extract-rspack-plugin
export default {"cls1":"AccountMenuButton-cls1_20q","cls2":"AccountMenuButton-cls2_wmZ AccountMenuButton-cls1_20q"};